// @flow

import { store } from '../../network/reduce';
import type { ApolloConfiguration, ModalElements } from '../../types/commonTypes';
import {
  APOLLO_CONFIGURATION,
  initialState,
  OPEN_KEEPEEK_MODAL,
  SAVE_DISABLED_NO_DATA,
} from './pageReducer';

export function openModalWithElements(elements: ModalElements) {
  return (dispatch: () => void) => {
    dispatch(store(OPEN_KEEPEEK_MODAL, elements));
  };
}

export function closeModal() {
  return (dispatch: () => void) => {
    dispatch(store(OPEN_KEEPEEK_MODAL, initialState.openModal));
  };
}

export function setApolloConfiguration(apolloConfiguration: ApolloConfiguration) {
  return (dispatch: () => void) => {
    dispatch(store(APOLLO_CONFIGURATION, apolloConfiguration));
  };
}

export const resetDisabledNoDataTabs = (): Function =>
  (dispatch: () => void) =>
    dispatch(saveDisabledNoDataTabs([]));

export const addToDisabledNoDataTabs = (disabledNoDataTab: string): Function =>
  (dispatch: () => void, getState: Function) => {
    const oldState = getState().page.disabledNoDataTabs;
    dispatch(saveDisabledNoDataTabs([...oldState, disabledNoDataTab]));
  };

const saveDisabledNoDataTabs = (disabledNoDataTabs: string[]): Function =>
  (dispatch: () => void) => dispatch(store(SAVE_DISABLED_NO_DATA, disabledNoDataTabs));
